<template>
    <el-dropdown trigger='click' @command="handleCommand" @visible-change="visibleChange">
        <span class="el-dropdown-link">
            <!-- signed in head-->
            <i v-if="visible === false && isUserCenterAvailable" class="el-icon-user-solid head" style="font-size:24px"></i>
            <i v-else-if="isUserCenterAvailable" class="el-icon-close head" style="font-size:24px"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="width: 180px">
            <template v-if="!isEmailActiviated">
                <el-tooltip v-if="!isMobileAgent" content="激活邮箱，获赠积分" placement="left">
                    <el-dropdown-item icon="el-icon-circle-check" command="activate-email">
                        <!-- 如果要把 el-tooltip 放到里面，这里必须使用 div with inline-block，否则宽度不会生效；设置宽度是为了增加 tootip 的触发宽度 -->
                        <div style="display:inline-block;">激活邮箱</div>
                    </el-dropdown-item>
                </el-tooltip>
                <el-dropdown-item v-else icon="el-icon-circle-check" command="activate-email">
                    <!-- 如果要把 el-tooltip 放到里面，这里必须使用 div with inline-block，否则宽度不会生效；设置宽度是为了增加 tootip 的触发宽度 -->
                    <div style="display:inline-block;">激活邮箱</div>
                </el-dropdown-item>
            </template>
            <!--<el-dropdown-item icon="el-icon-add-location" command="invite-code">我的邀请码</el-dropdown-item>-->
            <el-dropdown-item icon="iconfont icon-sy-invite" command="invite-code" v-if="isDisplayInviteCode">我的邀请码</el-dropdown-item>
            <el-dropdown-item v-if="isEmailActiviated && isDisplayInviteCode" icon="el-icon-chat-line-square" command="invite-his">我的邀请记录</el-dropdown-item>
            <!-- 当邮件已激活并且 not display invite code 的时候，我的账户上的分割线不要显示 -->
            <el-dropdown-item icon="el-icon-user" command="myaccount" :divided="!isEmailActiviated || isDisplayInviteCode">我的账户</el-dropdown-item>
            <el-dropdown-item icon="el-icon-lock" command="change-password">更改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-time" command="myviewhis" :divided="true">我的浏览历史</el-dropdown-item>
            <!-- TODO_ 下面的 el-tooltip 有关的 v-if/else 是否可以通过样式的方式消除？是否是因为 hover 导致点击有时候失效？ 答案是不可以，因为 el-tooltip 组件是动态添加到 body 元素中的，局部样式修正对其无效-->
            <el-tooltip v-if="!isMobileAgent" content="喜欢的视频图集列表" placement="left">
                <!-- 阿里的 iconfont 的 icon 和文字之间均与 element ui 向右偏移了一个像素，使用 margin-left 修复 -->
                <el-dropdown-item icon="iconfont icon-sy-love-2" command="mylikes">
                    <span style="margin-left:-1px">我的喜欢列表</span>
                </el-dropdown-item>
            </el-tooltip>
            <el-dropdown-item v-else icon="iconfont icon-sy-love-2" command="mylikes">
                <span style="margin-left:-1px">我的喜欢列表</span>
            </el-dropdown-item>
            <el-tooltip v-if="!isMobileAgent" content="收藏的视频图集列表" placement="left">
                <el-dropdown-item icon="el-icon-star-off" command="myfavorites">我的收藏列表</el-dropdown-item>
            </el-tooltip>
            <el-dropdown-item v-else icon="el-icon-star-off" command="myfavorites">我的收藏列表</el-dropdown-item>
            <el-tooltip v-if="!isMobileAgent" content="关注的博主列表" placement="left">
                <el-dropdown-item icon="el-icon-collection-tag" command="myfollows">我的关注列表</el-dropdown-item>
            </el-tooltip>
            <el-dropdown-item v-else icon="el-icon-collection-tag" command="myfollows">我的关注列表</el-dropdown-item>
            <!-- <el-dropdown-item icon="el-icon-download" command="mydownloads" :divided="true">我的下载列表</el-dropdown-item>-->
            <el-dropdown-item icon="el-icon-download" command="mydeals" :divided="true">我的下载记录</el-dropdown-item>
            <el-dropdown-item icon="el-icon-chat-round" command="mycomments" :divided="true">我的评论记录</el-dropdown-item>
            <!-- 阿里的 iconfont 的 icon 和文字之间均与 element ui 向右偏移了一个像素，使用 margin-left 修复 -->
            <el-dropdown-item icon="iconfont icon-sy-thumb-up-2" command="mycommentlikes">
                <span style="margin-left:-1px">我点赞的评论</span>
            </el-dropdown-item>
            <el-dropdown-item icon="iconfont icon-sy-log-out" :divided="true" command="signout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
        <!-- 下面是隐藏的 User Center Dialogs -->
        <user-activate-email ref="userActiviateEmail"></user-activate-email>
        <user-invite-code ref="userInviteCode"></user-invite-code>
        <user-invite-his ref="userInviteHis"></user-invite-his>
        <user-info ref="userInfo"></user-info>
        <user-change-password ref="userChangePassword"></user-change-password>
        <!-- 该组件被移动至上一级 Header.vue 中，以支持 stickpops -->
        <!-- <user-view-his ref="userViewHis"></user-view-his> -->
        <user-favor-likes ref="userLikes"
                          title="我的喜欢列表"
                          :shortcodes="this.$store.state.user !== null ? this.$store.state.user.likes : []"
                          un-favor-likes-event-name="unlikes"
                          un-favor-likes-confirm-mode-name="setUnLikeConfirmMode" />
        <!-- 该组件被移动至上一级 Header.vue 中，以支持 stickpops -->
        <!-- <user-deal-his ref="userDealHis"></user-deal-his>-->
        <user-favor-likes ref="userFavorites"
                          title="我的收藏列表"
                          :shortcodes="this.$store.state.user !== null ? this.$store.state.user.favorites : []"
                          un-favor-likes-event-name="unfavorites"
                          un-favor-likes-confirm-mode-name="setUnFavoriteConfirmMode" />
        <!-- 该组件被移动至上一级 Header.vue 中，以支持 stickpops -->
        <!-- <user-follows ref="myFollows"></user-follows>-->
        <user-comments ref="myCommentHis" :get-comments-handler="__getHisComments()"></user-comments>
        <user-comments ref="myCommentLikesHis" :get-comments-handler="__getHisCommentLikes()"></user-comments>
    </el-dropdown>
</template>

<script>
    import {signout, anoms} from "../../../data/user";
    import {loadingInstance, successMessage, warningMessage, isMobileAgent, getMyHeader, Constants} from "../../../utils";
    import {getHisComments, getHisCommentLikes} from "../../../data/comment";
    import UserInfo from "./UserInfo";
    import UserFavorLikes from "./UserFavorLikes";
    import UserComments from "./UserCommentsTemplate";
    import UserActivateEmail from "./UserActivateEmail";
    import UserInviteCode from "./UserInviteCode";
    import UserInviteHis from "./UserInviteHis";
    import UserChangePassword from "./UserChangePassword";
    import UserDealHis from "./UserDealHis";
    import UserViewHis from "./UserViewHis";

    export default {
        name: "Menu",
        components: {
            UserViewHis,
            UserInviteHis,
            UserDealHis,
            UserChangePassword,
            UserInviteCode, UserActivateEmail, UserComments, UserFavorLikes, UserInfo},
        data() {
            return {
                command: null,
                visible: false
            }
        },
        computed: {
            /* @since v2.3.0 避免免费用户蹭流量！
             * 注意：
             *  1. 当 visible === false 的时候才会显示
             *  2. 埋了个桩：只有 admin 账户的名称才会显示 ... */
            isUserCenterAvailable() {
                return this.$store.state.user.username === 'shangyang';
            },
            isMobileAgent() {
                return isMobileAgent();
            },
            isEmailActiviated() {
                return this.$store.state.user !== null ? this.$store.state.user.is_email_activated: false;
            },
            // 网上有人说，invite code 苹果不允许，因此作为敏感内容后端配置展示
            isDisplayInviteCode(){
                return this.$store.state.displayCtrl === null ? false : this.$store.state.displayCtrl.inviteCode;
            }
        },
        methods: {
            // drop down menu 展开或者关闭时回调，当展开的时候，返回 true else false
            visibleChange(isVisible){
                this.visible = isVisible;
            },
            handleCommand(command){
                console.log(`handleCommand() with command ${command}`);
                this.command = command;
                switch (command) {
                    case 'activate-email':
                        this.__show_activate_email();
                        break;
                    case 'invite-code':
                        this.__show_invite_code();
                        break;
                    case 'invite-his':
                        this.__show_invite_his();
                        break;
                    case 'myaccount':
                        this.__show_userinfo();
                        break;
                    case 'change-password':
                        this.__change_password();
                        break;
                    case 'myviewhis':
                        this.__show_myviewhis();
                        break;
                    case 'mylikes':
                        this.__show_mylikes();
                        break;
                    case 'myfavorites':
                        this.__show_myfavorites();
                        break;
                    case 'myfollows':
                        this.__show_myfollows();
                        break;
                    case 'mydeals':
                        this.__show_mydeals();
                        break;
                    case 'mycomments':
                        this.__show_mycomments();
                        break;
                    case 'mycommentlikes':
                        this.__show_mycommentlikes();
                        break;
                    case 'signout':
                        this.__signout();
                        break;
                }
            },

            __signout(){
                let loading = loadingInstance();
                async function handle(){
                    try {
                        let r = await signout.bind(this)();
                        if (r.success) {
                            this.$parent.isSignedIn = false;
                            successMessage('你已成功登出');
                            await anoms(); // 当退出后，立刻再次得到一个匿名账号
                        } else {
                            warningMessage('网络异常，登出失败，请稍后再试');
                        }
                    }finally{
                        loading.close();
                    }
                }
                handle.bind(this)();
            },

            __show_activate_email(){
                this.$refs.userActiviateEmail.show();
            },

            __show_invite_code(){
                this.$refs.userInviteCode.show();
            },

            __show_invite_his(){
                this.$refs.userInviteHis.show();
            },

            __show_userinfo(){
                this.$refs.userInfo.show();
            },

            __change_password(){
                this.$refs.userChangePassword.show();
            },

            __show_myviewhis(){
                getMyHeader().$refs.userViewHis.show();
            },

            __show_mylikes(){
                this.$refs.userLikes.show();
            },

            __show_myfavorites(){
                this.$refs.userFavorites.show();
            },

            __show_myfollows(){
                getMyHeader().$refs.myFollows.show();
            },

            __show_mydeals(){
                getMyHeader().$refs.userDealHis.show();
            },

            __show_mycomments(){
                this.$refs.myCommentHis.show();
            },

            __show_mycommentlikes(){
                this.$refs.myCommentLikesHis.show();
            },

            __getHisComments(){
                return getHisComments;
            },

            __getHisCommentLikes(){
                return getHisCommentLikes;
            }
        }
    }
</script>

<style scoped>

    /* =============== iconfont 调整 =============== */
    /* iconfont 的尺寸和 element-icons 大小上有些许的像素级别的差距，因此这里进行微调 */
    /deep/ .icon-sy-love-2{
        margin-left: -1px !important;
    }

    /deep/ .icon-sy-thumb-up-2{
        margin-left: -1px !important;
    }

    /deep/ i.iconfont.icon-sy-thumb-up-2{
        font-size: 14px !important;
    }

    /deep/ i.iconfont.icon-sy-invite{
        font-size: 14px !important;
    }

    .head {
        cursor: pointer
    }

    /* hover 事件只做用在 PC 端*/
    @media (min-width: 736px) {
        .head:hover {
            color: #CB0101
        }
    }

    /* hover 事件只做用在 PC 端*/
    @media (max-width: 735px) {
        /* 禁止原生的蓝色的 Menu 的 background color */
        /deep/ .el-dropdown-menu__item {
            color: #303133 !important;
            background-color: #FFFFFF !important;
        }
    }

    /* hover 事件只做用在 PC 端*/
    @media (min-width: 736px) {
        /* 设置 el-dropdown-item 激活后的样式 */
        /deep/ .el-dropdown-menu__item:hover {
            color: #CB0101 !important; /* 发现 deep 发布到 nginx 后无效，需要使用 !important */
            background-color: #FDF7F6 !important;
        }
    }

    /deep/ .el-dropdown-menu__item{
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-size: 14px;
    }



</style>



// WEBPACK FOOTER //
// src/components/user/center/Menu.vue